module.exports = __webpack_public_path__ + "img/259.app_revealed.a9782129.svg";